import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import sentGAEvent from '@/ga';
import { Col, Row } from 'antd';
import Upload from '@/components/upload/Upload';
import Process from '@/components/common/process/Process';
import actions from '@/redux/action';
import Utils from '@/utils';
import { request } from '@/api/request';
import moment from 'moment';
import cutoutPicture from '@/assets/images/image-cutout.png';
import samplePicture10 from '@/assets/images/imgae-cutout-sample-10.png';
import samplePicture6 from '@/assets/images/imgae-cutout-sample-6.png';
import samplePicture7 from '@/assets/images/imgae-cutout-sample-7.png';
import samplePicture11 from '@/assets/images/imgae-cutout-sample-11.png';
import samplePicture9 from '@/assets/images/imgae-cutout-sample-9.png';
import retryPic from '@/assets/icons/retry.svg';
import ImageCutoutUploadSuccessFunction from './children/imageCutoutUploadSuccessFunction/ImageCutoutUploadSuccessFunction';
import ImageCutoutEditWorkFunction from './children/imageCutoutEditWorkFunction/ImageCutoutEditWorkFunction';
import { api_config } from '@/constants/api';
import Cookies from 'js-cookie';
import api_domain_config from '@/constants/common';
import { accountList } from '@/constants/url';

import '@/assets/imageCutout.less';

class ImageCutoutWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlaceVisible: false,
      imageAccept: '.jpeg,.jpg,.png,.bmp,',
      processText: 'Uploading',
      uploading: false,
      submitting: false,
      editorVisible: false,
      sampleImageList: [
        {
          fileurl: api_config.SAMPLE_PIC_URL + '/5.png',
          width: 870,
          height: 580,
        },
        {
          fileurl: api_config.SAMPLE_PIC_URL + '/4.png',
          width: 870,
          height: 1024,
        },
        {
          fileurl: api_config.SAMPLE_PIC_URL + '/3.png',
          width: 676,
          height: 850,
        },
        {
          fileurl: api_config.SAMPLE_PIC_URL + '/1.png',
          width: 870,
          height: 565,
        },
        {
          fileurl: api_config.SAMPLE_PIC_URL + '/2.png',
          width: 722,
          height: 883,
        },
      ],
      uploadFailed: false,
    };
    this.file_url = '';
    this.tempFileName = '';
  }
  componentDidMount() {
    window.addEventListener('online', () => {
      if (this.onlineShouldGa) {
        this.onlineShouldGa = false;
        console.log('联网后重新传GA，只能出发一次');
        sentGAEvent({
          category: 'BG_remove_result',
          action: 'fail',
        });
      }
    });
  }
  //1、首先是上传文件的方法
  addFileCallBack = async (imageCutoutObj) => {
    this.imageCutoutObj = imageCutoutObj;
    console.log('imageCutoutObj-------------------', imageCutoutObj);
    this.base64 = await Utils.getBase64(imageCutoutObj.fileObj); //得到上传图片的base64
    //以下为计算进度条及预览宽高的计算
    this.imgWH = await Utils.getWH(this.base64); //得到上传图片的宽高
    console.log(
      window.screen.height,
      window.screen.availHeight,
      '3333333333333'
    );
    let maxHeight = Math.max(window.innerHeight - 500, 348);
    let frameWidth = 348;
    let rate = frameWidth / this.imgWH.width;
    //图片根据宽度缩放
    this.width = frameWidth;
    this.height = this.imgWH.height * rate;
    if (this.height > maxHeight) {
      //如果缩放完毕超出网页可见高度
      this.width = this.width / (this.height / maxHeight);
      this.height = maxHeight;
    }
    const startTime = { ...this.props.startTime }; //从store里得到开始时间对象，可能为空
    startTime.upload = new Date().valueOf(); //时间对象的upload属性设为现在上传的时间
    this.props.onStartTimeChange(startTime); //写回到store里
    this.tempFileName =
      this.props.authorization.split('.')[2] + new Date().getTime();
    this.handleUpload(imageCutoutObj); //从组件中得到imageCutoutObj传到处理上传事件
    this.props.onImageCutoutObjChange(imageCutoutObj); //把对象存到store imageCutoutObj的key里
  };

  handleSubmitFail = (error) => {
    if (error !== 'cancel') {
      this.setState({
        submitStatus: 'failed',
      });
    }
    this.setState({ submitting: false, uploading: false });
    this.props.onProcessPercentChange(0);
    this.props.onProcessStepChange(0);
    this.props.onUploadPercentChange(0);
  };
  //这个是上传完，点去背景按钮执行的方法
  handleSubmit = async () => {
    // const startTime = {...this.props.startTime}
    // startTime.imagecutout = new Date().valueOf()
    // this.props.onStartTimeChange(startTime);
    this.cancelWork = false;
    this.setState({ submitting: true, processText: 'Compressing' });
    this.props.onProcessStepChange(1);
    this.props.onProcessPercentChange(50);
    const imageCutoutObj = { ...this.props.imageCutoutObj };
    let workResponse;
    try {
      workResponse = await this.requstImageCutout(imageCutoutObj.fileurl);
    } catch (error) {
      if (error !== 'cancel') {
      }
      if (!window.navigator.onLine) this.onlineShouldGa = true;
      sentGAEvent({
        category: 'BG_remove_result',
        action: 'fail',
      });
      this.handleSubmitFail(error);
      return false;
    }
    if (this.cancelWork) {
      this.handleSubmitFail('cancel');
      return false;
    }
    if (workResponse.code === 200) {
      if (workResponse.data.result.number) {
        sentGAEvent({
          category: 'BG_remove_result',
          action: 'success',
        });
        sentGAEvent({
          category: 'ProcessStart',
          action: '07BC_ProcessStart',
          label: 'Null',
        });
        imageCutoutObj.cutoutfilename =
          moment(new Date().valueOf()).format('YYYYMMDDHHmmss') + '.png';
        imageCutoutObj.cutoutfileurl = workResponse.data.response_file[0];
        imageCutoutObj.downloadurl = workResponse.data.response_file[0];
        let respone = await fetch(workResponse.data.response_file[1]);
        let responeBlob = await respone.blob();
        this.preBase = await Utils.getBase64(responeBlob);
        this.setState({
          submitting: false,
          submitStatus: 'success',
        });
        sentGAEvent({
          category: 'ProcessSuccess',
          action: '07BC_ProcessSuccess',
          label: 'Null',
        });
        this.props.onImageCutoutObjChange(imageCutoutObj);
        this.props.onProcessPercentChange(0);
        this.props.onProcessStepChange(0);
        this.props.onUploadPercentChange(0);
      }
    } else {
      if (workResponse.code === 402102) {
        sentGAEvent({
          category: 'UpgradePrompShow',
          action: '07BC_UpgradePrompShow',
        });
        this.props.onPurchaseModalObjChange({
          visible: true,
          type: 'videoEditorTimesMoreThanLimit',
        });
        this.handleSubmitFail('cancel');
      } else if (workResponse.code === 401) {
      } else {
        sentGAEvent({
          category: 'BG_remove_result',
          action: 'fail',
        });
        this.handleSubmitFail();
      }
      return false;
    }
  };

  handleUpload = async (imageCutoutObj) => {
    this.cancelWork = false;
    this.setState({
      uploadFailed: false,
    });
    this.setState({ uploading: true, processText: 'Uploading' }); //uploading影响进度条的显隐，processText为进度条文本。
    this.props.onProcessStepChange(2); //processStep进度条组会用,作为分母
    if (!imageCutoutObj.uploadStatus) {
      //如果还没上传成功才走
      let fileResponse;
      try {
        fileResponse = await this.requestUploadImageFile(
          //调接口上传，UploadPercentChange
          imageCutoutObj.fileObj
        );
      } catch (error) {
        if (error !== 'cancel') {
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerFail',
            label: error + '_none_none_' + this.props.tokenId + '_none_none',
          });
          this.setState({ uploadFailed: true });
        }
        this.handleSubmitFail(error); //参数只用来标志埋点
        return false;
      }
      if (this.cancelWork) {
        this.handleSubmitFail('cancel');
        return false;
      }
      if (fileResponse.code === 200) {
        sentGAEvent({
          category: 'UploadSuccess',
          action: '07BC_UploadSuccess',
          label: 'Null',
        });
        //如果上传成功了
        if (fileResponse.data.result.number) {
          const fileResponseNumber = fileResponse.data.result.number;
          const fileResponseUrl =
            fileResponse.data.response_file[0].split('?')[0];
          this.file_url = fileResponse.data.response_file[0].split('?')[0];
          let fileProcess;
          try {
            // fileProcess = await Utils.getProgress(fileResponseNumber, false);//processPercent会改变，fileResponseNumber为处理数量
          } catch (error) {
            console.log('error', error);
            if (error !== 'cancel') {
              sentGAEvent({
                category: 'Upload',
                action: 'LocalSerFail',
                label: 'uploadImage' + '_200_200_' + error,
              });
            }
            this.handleSubmitFail(error);
            return false;
          }
          sentGAEvent({
            category: 'Upload',
            action: 'LocalSerSuccess',
          });
          imageCutoutObj.fileurl = fileResponseUrl; //存各种文件信息
          imageCutoutObj.status = 'uploaded';
          imageCutoutObj.uploadStatus = true;
          imageCutoutObj.width = this.imgWH.width;
          imageCutoutObj.height = this.imgWH.height;
          // imageCutoutObj.width = fileProcess.info[0].wh.substring(
          //   0,
          //   fileProcess.info[0].wh.indexOf('x')
          // );
          // imageCutoutObj.height = fileProcess.info[0].wh.substring(
          //   fileProcess.info[0].wh.indexOf('x') + 1
          // );

          sentGAEvent({
            category: 'BG_add_files',
            action: 'BG_add_files',
            label: `${
              imageCutoutObj.name.split('.')[
                imageCutoutObj.name.split('.').length - 1
              ]
            }_${(imageCutoutObj.size / 1024).toFixed(2)}kb_${
              imageCutoutObj.width
            }*${imageCutoutObj.height}`,
          });
          this.props.onImageCutoutObjChange(imageCutoutObj); //文件信息对象存到store里
          // this.setState({ frameRate: fileProcess.info[0].fps });//存帧率
        }
      } else {
        this.setState({ uploadFailed: true });
        sentGAEvent({
          category: 'Upload',
          action: 'LocalSerFail',
          label:
            'uploadImage' +
            '_200_' +
            fileResponse.code +
            '_none_' +
            this.props.tokenId +
            '_none_' +
            fileResponse.msg,
        });
        this.handleSubmitFail();
        if (fileResponse.code === 401) {
          Cookies.remove('authorization', { domain: api_domain_config.DOMAIN });
          let hostName = window.location.hostname;
          Cookies.remove('access_token', {
            domain: hostName.substring(
              window.location.hostname.indexOf('.'),
              hostName.length
            ),
          });
          Cookies.remove('access_token_expires_in', {
            domain: hostName.substring(hostName.indexOf('.'), hostName.length),
          });
          window.location.replace(
            `${accountList.get('login')}?redirect=${window.location.href}`
          );
        }
        return false;
      }
      this.setState({
        uploading: false,
        submitStatus: 'waiting',
      });
      this.props.onProcessPercentChange(0);
      this.props.onProcessStepChange(0);
      this.props.onUploadPercentChange(0);
    }
  };
  preSignUrl = (file) => {
    const formData = new FormData();
    formData.append('filename', this.tempFileName);
    formData.append('content-length', file.size);
    formData.append('content-type', file.type);
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `${api_config.API_URL}/preSignUrl`, true);
      xhr.setRequestHeader('authorization', this.props.authorization);

      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.uploadPercent < 100) {
            this.props.onUploadPercentChange(percent);
          } else {
            this.props.onUploadPercentChange(
              percent +
                (this.props.uploadPercent - (this.props.uploadPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadImage_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        resolve(JSON.parse(xhr.response));
        this.setState({ uploadXHR: null });
        this.props.onUploadXHRChange(null);
      };
      xhr.send(formData);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };
  putOss = (url, file) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', `${url}`, true);
      xhr.setRequestHeader('X-Oss-Object-Acl', 'public-read');
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          let percent = parseInt((event.loaded / event.total) * 100);
          if (this.props.processPercent < 100) {
            this.props.onProcessPercentChange(percent);
          } else {
            this.props.onProcessPercentChange(
              percent +
                (this.props.processPercent - (this.props.processPercent % 100))
            );
          }
        }
      };
      xhr.onerror = () => {
        reject('uploadImage_' + xhr.status);
      };
      xhr.onabort = () => {
        reject('cancel');
      };
      xhr.upload.onabort = () => {
        reject('cancel');
      };
      xhr.onload = () => {
        this.setState({ uploadXHR: null });
        this.props.onUploadXHRChange(null);
        resolve('');
      };
      xhr.send(file);
      this.setState({ uploadXHR: xhr });
      this.props.onUploadXHRChange(xhr);
    });
  };
  requestUploadImageFile = async (file) => {
    sentGAEvent({
      category: 'UploadStart',
      action: '07BC_UploadStart',
      label: 'Null',
    });
    sentGAEvent({
      category: 'Upload',
      action: 'LocalSerStart',
    });

    return new Promise(async (resolve, reject) => {
      try {
        let preSignUrlRes = await this.preSignUrl(file);
        if (preSignUrlRes.code != 200) {
          if (preSignUrlRes.code == 401) {
            Cookies.remove('authorization', {
              domain: api_domain_config.DOMAIN,
            });
            window.location.replace(
              `${accountList.get('login')}?redirect=${window.location.href}`
            );
          }
          console.log('上传oss preSignUrl步骤出错');
          return;
        }
        let putOssRes = await this.putOss(
          preSignUrlRes.data.response_file[0],
          file
        );
        if (putOssRes == '') {
          resolve(preSignUrlRes);
        }
        reject('上传失败', putOssRes);
      } catch (error) {
        reject('上传失败', error);
      }
    });
  };
  // requestUploadImageFile = (file) => {
  //   sentGAEvent({
  //     category: 'Upload',
  //     action: 'LocalSerStart',
  //   });
  //   const formData = new FormData();
  //   formData.append('files[]', file);
  //   formData.append('token', this.props.tokenId);
  //   return new Promise((resolve, reject) => {
  //     const xhr = new XMLHttpRequest();
  //     xhr.open('POST', `${api_config.API_URL}/uploadImage`, true);
  //     xhr.setRequestHeader('authorization', this.props.authorization);

  //     xhr.upload.onprogress = (event) => {
  //       if (event.lengthComputable) {
  //         let percent = parseInt((event.loaded / event.total) * 100);
  //         if (this.props.uploadPercent < 100) {
  //           this.props.onUploadPercentChange(percent);
  //         } else {
  //           this.props.onUploadPercentChange(
  //             percent +
  //               (this.props.uploadPercent - (this.props.uploadPercent % 100))
  //           );
  //         }
  //       }
  //     };
  //     xhr.onerror = () => {
  //       reject('uploadImage_' + xhr.status);
  //     };
  //     xhr.onabort = () => {
  //       reject('cancel');
  //     };
  //     xhr.upload.onabort = () => {
  //       reject('cancel');
  //     };
  //     xhr.onload = () => {
  //       resolve(JSON.parse(xhr.response));
  //     };
  //     xhr.send(formData);
  //     this.setState({ uploadXHR: xhr });
  //     this.props.onUploadXHRChange(xhr);
  //   });
  // };

  requstImageCutout = (file_url) => {
    // const formData = new FormData();
    // formData.append('file_url', this.file_url);
    // formData.append('token', this.props.tokenId);
    // return new Promise((resolve, reject) => {
    //   request(`matting`, {
    //     method: 'post',
    //     body: formData,
    //   })
    //     .then((response) => {
    //       resolve(response);
    //     })
    //     .catch((error) => {
    //       reject(error);
    //     });
    // });
    let data = {
      file_url: this.file_url,
      token: this.props.tokenId,
    };
    return new Promise((resolve, reject) => {
      request(`matting`, {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  handleClose = () => {
    console.log('点击了来来来');
    if (!this.state.uploading && !this.state.submitting) {
      this.props.onImageCutoutObjChange(null);
    } else {
      console.log('取消');
      this.setState({
        submitting: false,
        uploading: false,
        submitStatus: 'waiting',
      });
      this.props.onProcessPercentChange(0);
      this.props.onProcessStepChange(0);
      this.props.onUploadPercentChange(0);
      this.props.onImageCutoutObjChange(null);
      this.props.onUploadXHRChange(null);
      const xhr = this.props.uploadXHR;
      if (
        xhr &&
        this.props.uploadPercent <
          (this.props.uploadNumber ? this.props.uploadNumber * 100 : 100)
      ) {
        xhr.abort();
      } else {
        if (this.props.fetchAbort) {
          this.props.fetchAbort();
        }
        Utils.cancleProgress();
      }
      this.cancelWork = true;
    }
  };

  cancelProcessCallBack = () => {
    sentGAEvent({
      category: 'Upload',
      action: 'LoadCancel',
      label:
        (this.imageCutoutObj.fileObj.size / 1024 / 1024).toFixed(2) +
        'm_' +
        (new Date().getTime() - this.props.startTime.upload) / 1000 +
        's',
    });
    this.setState({
      uploadFailed: false,
    });
    this.setState({
      uploading: false,
    });
    this.props.onImageCutoutObjChange(null);
  };

  cancelRemoveProcessCallBack = () => {
    // sentGAEvent({
    //   category: "Upload",
    //   action: "LoadCancel",
    //   label: (new Date().getTime() - this.props.startTime.imagecutout) / 1000,
    // });
    this.setState({
      submitting: false,
    });
  };

  handleLoadSamplePhoto = async (i) => {
    sentGAEvent({
      category: 'BG_sample',
      action: 'BG_sample_click',
    });
    const imageCutoutObj = this.state.sampleImageList[i];
    this.file_url = imageCutoutObj.fileurl;
    let respone = await fetch(imageCutoutObj.fileurl);
    let responeBlob = await respone.blob();
    this.base64 = await Utils.getBase64(responeBlob);
    let frameWidth = 348;
    let rate = frameWidth / imageCutoutObj.width;
    //图片根据宽度缩放
    this.width = frameWidth;
    this.height = imageCutoutObj.height * rate;
    let maxHeight = Math.max(window.innerHeight - 500, 348);
    if (this.height > maxHeight) {
      //如果缩放完毕超出网页可见高度
      this.width = this.width / (this.height / maxHeight);
      this.height = maxHeight;
    }
    imageCutoutObj.status = 'uploaded';
    imageCutoutObj.uploadStatus = true;

    this.props.onImageCutoutObjChange(imageCutoutObj); //store里的imageCutoutObj变，就会到上传成功页。
  };

  handleShowEditor = () => {
    sentGAEvent({
      category: 'BG_edit',
      action: 'BG_edit_click',
    });
    this.setState({ editorVisible: true });
  };

  render() {
    console.log(this.state.uploading);

    const { t, pageType } = this.props;
    return (
      <div
        style={!this.state.editorVisible ? { padding: '77px 24px 85px' } : {}}
      >
        {!this.state.editorVisible ? (
          <div className='work-hd'>
            <h1>{t(`imageCutout:${pageType}:title`)}</h1>
            <p>{t(`imageCutout:${pageType}:desc`)}</p>
          </div>
        ) : null}
        {(this.state.uploading && this.props.imageCutoutObj) ||
        this.state.uploadFailed ? (
          <div
            style={{
              position: 'relative',
              width: this.width,
              height: this.height,
              margin: 'auto',
              maxWidth: '100%',
            }}
          >
            {this.state.uploadFailed ? (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  zIndex: 3,
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={retryPic}
                    onClick={() => this.addFileCallBack(this.imageCutoutObj)}
                    style={{ cursor: 'pointer', marginBottom: 12 }}
                    alt=''
                  />
                  <div>{t('Upload failed, click to try again')}</div>
                </div>
              </div>
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'absolute',
                  zIndex: 2,
                  opacity: 0.6,
                }}
              >
                <Process
                  visible
                  type='square'
                  theme='dark'
                  showProcessText
                  processText={this.state.processText}
                  hideCancelText
                  cancelProcessCallBack={this.cancelProcessCallBack}
                  isPicRemoveBg={true}
                />
              </div>
            )}
            <div
              style={{
                width: '100%',
                height: '100%',
                position: 'absolute',
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <img
                src={this.base64}
                style={{ width: this.width, height: this.height }}
                alt=''
              ></img>
            </div>
          </div>
        ) : !this.props.imageCutoutObj ? (
          <div className='work-pre container'>
            <div span={12}>
              <img src={retryPic} style={{ display: 'none' }} alt='' />
              <Upload
                visible
                accept={this.state.imageAccept}
                addFileCallBack={this.addFileCallBack}
                uploadMaxCount={1}
              />
              <Row className='sample-list' gutter={[16, 16]} align='middle'>
                <Col>
                  <span>{t('Sample photo')}</span>
                </Col>
                <Col onClick={() => this.handleLoadSamplePhoto(0)}>
                  <img src={samplePicture10} alt='sample 1' />
                </Col>
                <Col onClick={() => this.handleLoadSamplePhoto(1)}>
                  <img src={samplePicture6} alt='sample 2' />
                </Col>
                <Col onClick={() => this.handleLoadSamplePhoto(2)}>
                  <img src={samplePicture7} alt='sample 3' />
                </Col>
                <Col onClick={() => this.handleLoadSamplePhoto(3)}>
                  <img src={samplePicture11} alt='sample 4' />
                </Col>
                <Col onClick={() => this.handleLoadSamplePhoto(4)}>
                  <img src={samplePicture9} alt='sample 1' />
                </Col>
              </Row>
            </div>
            <img
              className='main-picture'
              src={cutoutPicture}
              alt={t(`imageCutout:${pageType}:imgAlt`)}
            />
          </div>
        ) : this.state.editorVisible ? (
          <ImageCutoutEditWorkFunction
            imageCutoutObj={this.props.imageCutoutObj}
            imageAccept={this.state.imageAccept}
            handelRebackToUploadSuccessPage={() =>
              this.setState({ editorVisible: false })
            }
            base64={this.base64}
          />
        ) : (
          <ImageCutoutUploadSuccessFunction
            handleShowEditor={this.handleShowEditor}
            imageCutoutObj={this.props.imageCutoutObj}
            submitting={this.state.submitting}
            handleSubmit={this.handleSubmit}
            handleClose={this.handleClose}
            cancelRemoveProcessCallBack={this.cancelRemoveProcessCallBack}
            pageType={this.props.pageType}
            base64={this.base64}
            preBase={this.preBase}
            calWidth={this.width}
            calheight={this.height}
          />
        )}
      </div>
    );
  }
}

const mapStateToPropos = (state) => ({
  imageCutoutObj: state.work.imageCutoutObj,
  tokenId: state.common.tokenId,
  uploadPercent: state.work.uploadPercent,
  processPercent: state.work.processPercent,
  uploadXHR: state.work.uploadXHR,
  fetchAbort: state.work.fetchAbort,
  startTime: state.work.startTime,
  authorization: state.common.authorization,
});

const mapDispatchToProps = (dispatch) => ({
  onImageCutoutObjChange: (imageCutoutObj) =>
    dispatch(actions.onImageCutoutObjChange(imageCutoutObj)),
  onUploadPercentChange: (uploadPercent) =>
    dispatch(actions.onUploadPercentChange(uploadPercent)),
  onUploadXHRChange: (uploadXHR) =>
    dispatch(actions.onUploadXHRChange(uploadXHR)),
  onProcessStepChange: (processStep) =>
    dispatch(actions.onProcessStepChange(processStep)),
  onProcessPercentChange: (processPercent) =>
    dispatch(actions.onProcessPercentChange(processPercent)),
  onStartTimeChange: (startTime) =>
    dispatch(actions.onStartTimeChange(startTime)),
  onPurchaseModalObjChange: (purchaseModal) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModal)),
});

export default connect(
  mapStateToPropos,
  mapDispatchToProps
)(withTranslation(['imageCutout', 'common'])(ImageCutoutWork));
